import React from 'react';
import ReactPlayer from 'react-player';
import Header from './Header';
import Gallery01 from './Gallery01';
import Gallery02 from './Gallery02';
import Gallery03 from './Gallery03';
import Gallery04 from './Gallery04';
import Gallery05 from './Gallery05';
import Gallery06 from './Gallery06';
import Gallery07 from './Gallery07';
import * as S from './styles';

const Main: React.FC = () => {
  return (
    <S.Container>
      <Header />
      <S.Content>
        <S.Text>
          <p
            className="drop-caps wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Como a maioria dos desfiles de alta-costura da temporada de inverno
            2022, o da linha Artisanal da Maison Margiela foi presencial, com
            convidados e tudo mais. Ainda assim, o que se viu passa longe dos
            moldes convencionais. Para começar, não havia passarela, mas um
            palco – a locação era um teatro, com os convidados sentados na
            plateia. Era como se uma peça escrita pelo diretor de criação, John
            Galliano, e adaptada pelo grupo britânico Imitating the Dog
            estivesse sendo filmada ali mesmo, com os takes e cenas exibidos em
            tempo real em grandes telas, e tudo transmitido ao vivo.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            A história é um romance num clima de Velho Oeste misturado com road
            movie. Fala sobre as aventuras, os infortúnios e a fuga de um casal
            de enteados após conflitos com os pais abusadores. Envolve religião,
            construções sociais e mais um tanto de violências não muito
            diferentes das que acompanhamos pelo noticiário.
          </p>
        </S.Text>
        <S.WrapperWrapper>
          <S.VideoWrapper
            className="wow animate__animated animate__zoomIn"
            data-wow-duration="1s"
          >
            <ReactPlayer
              className="react-player"
              url="https://www.youtube.com/watch?v=-GI068lnT-M&t=1909s"
              width="100%"
              height="100%"
              controls
            />
          </S.VideoWrapper>
        </S.WrapperWrapper>
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            A apresentação aconteceu dias depois de uma série de tiroteios nos
            Estados Unidos. A encenação da Margiela começa e termina com armas
            sendo disparadas e pessoas feridas, algumas mortas. Teve quem
            achasse a coisa toda bem insensível, principalmente convidados e
            espectadores estadunidenses. É uma constatação válida, bem como a da
            pouca diversidade no casting, e que merece um pouco de
            aprofundamento.
          </p>
        </S.Text>
        <Gallery01 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            John Galliano não tinha como prever as tragédias à mão armada do
            outro lado do Atlântico, ainda assim a conexão entre ficção e
            realidade é inevitável. Até pela escolha do gênero Western.
            Essencialmente estadunidense, esse estilo tem relação direta com a
            fetichização da violência e sua imposição nos sistemas sociais,
            políticos e econômicos dominantes. É a lei do mais forte, que vence
            sempre pela força, pela violência. E, na versão hollywoodiana, o
            vencedor, o herói é sempre o mocinho bonito defensor dos bons
            costumes, da ordem e da moral.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            No faroeste fashionista da Margiela, são os bons costumes, a
            família, a tradição familiar e religiosa que infligem e incitam a
            violência. O crime? Uma paixão, um romance.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            <a href="https://www.youtube.com/watch?v=UuAdPiFROY4">
              No desfile de inverno 2018 da Calvin Klein
            </a>
            , Raf Simons, então diretor de criação da marca, fez uma analogia
            sobre como Hollywood é ao mesmo tempo reflexo e baliza de uma
            sociedade em determinados momentos da história. No inverno 2022 de
            alta-costura da Margiela, Galliano faz algo similar não só pela
            relação do cinema com o grande influenciador sociocultural (o clímax
            da peça-filme acontece numa sala de cinema), mas pelo atravessamento
            de diferentes camadas sociais, culturais e históricas.
          </p>
        </S.Text>
        <Gallery02 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            As roupas falam sobre isso, com suas sobreposições e justaposições
            de peças, técnicas e tecidos de épocas e estilos diferentes. Algumas
            peças, como os jeans e os trench coats, têm a aparência empoeirada.
            Não se sabe bem se pelo clima árido daquele faroeste ou pela
            passagem do tempo. Talvez os dois. Afinal, aquele pó também brilha,
            como uma versão glamourosa da areia dos sonhos de Sandman.
          </p>
        </S.Text>
        <Gallery03 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            John Galliano é apaixonado por histórias – reais e ficcionais – e
            isso transparece em sua criação. Se antes era de forma mais literal,
            agora é um tanto mais abstrata, como que num misto de memórias,
            lembranças não muito claras. Daí as camadas de transparência, que se
            acumulam em um só look. Um deles, por exemplo, é feito da junção de
            três vestidos transparentes. Há casacos que lembram criações couture
            de Hubert de Givenchy e Cristóbal Balenciaga. Outros fazem alusão
            aos vestidos de baile de Charles James. As costuras aparentes, um
            clássico de Margiela, aqui são menos técnicas ou sinais de
            desconstrução e mais uma referência às conexões entre passado e
            presente, imaginação e realidade, que nos constituem como seres
            humanos.
          </p>
        </S.Text>
        <Gallery04 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            O palco com equipe de filmagem e telas com imagens editadas da
            encenação representam uma realidade fragmentada e dependente da
            reprodução e transmissão digital e espetaculosa de tudo. Se não
            postou, não aconteceu. Ao mesmo tempo, a ausência dos objetos de
            cena, o vazio e a simplicidade à la Dogma 95 falam sobre a
            importância da imaginação para além do que os olhos veem, além do
            óbvio.
          </p>
        </S.Text>
        <Gallery05 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            O roteiro nada linear, quase num looping sem fim, não é muito
            diferente do que vemos, desejamos e consumimos, nesse remix infinito
            de hits do passado adaptados para o presente. E ao misturar
            referências de <em>Natural born killers</em>,{' '}
            <em>Bonnie and Clyde</em>, <em>Querelle</em>, <em>Dogville</em>,{' '}
            <em>Wild at heart</em>, <em>The handmaid's tale</em>, e até o clipe
            de <em>Telephone</em>, de Lady Gaga e Beyoncé, Galliano está só
            apontando como o cinema e mais todo o aparato da cultural pop
            influenciam nossa vida. Mais do que isso, está mostrando como nossa
            visão de mundo e nossa produção de conteúdo, e de mais um tudo, são
            o resultado de recortes e colagens de um sem-número de elementos.
          </p>
        </S.Text>
        <Gallery06 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Não faz muito tempo, gurus do marketing, da publicidade e da
            comunicação apontavam o storytelling como um dos principais caminhos
            para o sucesso no mercado da criação e produção de conteúdo. Não
            bastava só fazer imagens belas, era preciso engajar com a narrativa,
            contar uma história. 
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            A ideia fez sentido especialmente para as possibilidades que se
            abriam com a evolução das redes sociais, porém não se limitava ao
            digital. Nas passarelas, era cada vez mais necessário ter algo além
            das roupas para mostrar: um discurso político, uma experiência
            pessoal, uma lembrança cultural.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Com a chegada da covid-19, em 2020, ir além do produto se tornou
            ainda mais importante, e as limitações impostas pelas políticas
            sanitárias de contenção forçaram olhares e mentes para outras formas
            de apresentação e de contar histórias.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Mas bastaram algumas doses de vacina e quedas significativas no
            número de mortes e novas infecções para que alguns hábitos
            adquiridos durante os meses mais duros da pandemia fossem
            abandonados. Aconteceu com um tanto de coisas na nossa vida e
            aconteceu também com o filme de moda – ou o fashion film.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Além do nome péssimo, a ideia nunca decolou de fato. Tudo bem, era
            uma das poucas alternativas e, até certo ponto, pareceu ter
            potencial. Porém, após dois anos de tudo digital, ninguém aguentava
            mais ver modelos andando de um lado para o outro ou pessoas
            encenando alguma fração poética do cotidiano.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            O problema, contudo, é menos o formato e mais a falta de repertório,
            referências, investimentos e o apego às formas convencionais de
            narrativas cabíveis a um desfile – ou o que se espera dele. As
            inspirações continuam lá, as referências idem, mas é inegável que
            muita marca prefere se focar na quantidade de likes, reposts e
            influenciadores mimetizando seus looks – por espontânea vontade ou
            por acordo comercial – do que na história.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Quer dizer, a grande maioria. O que é uma pena. Afinal, como John
            Galliano deixou evidente, boas histórias também podem ser
            superinfluentes – com uma vida útil muito maior do que um meme. E
            aqui vale fazer um recorte no tempo.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            O estilista britânico sempre foi chegado a teatralidades e
            espetáculos nas passarelas. Na verdade, não só nelas. Durante os
            anos 1980 e 90, Galliano era frequentador assíduo da cena clubber
            londrina, onde cada item de roupa e cada look eram pensados não só
            para impactar, mas para contar ou criar alguma história e múltiplas
            personalidades.
          </p>
        </S.Text>
        <Gallery07 />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Na faculdade, a Central Saint Martins, em Londres, veio o contato
            com artes plásticas, literatura e teatro. Depois de formado, seus
            desfiles, em sua própria etiqueta e na Dior, onde atuou como diretor
            de criação de 1996 a 2011 (ele foi demitido após proferir
            verbalmente ataques racistas e xenófobos a um casal num bar em
            Paris), eram apoteóticos, carregados de referências históricas e
            paixões pessoais. Neles, nada era por acaso. Iluminação, trilha
            sonora, decoração, casting, atitude, passos e poses, cada detalhe
            era considerado como elemento de uma mesma narrativa.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Na Maison Margiela, marca pela qual foi contratado em 2014, sua
            abordagem é um pouco diferente. E aqui vale ressaltar que a grife,
            fundada pelo estilista belga{' '}
            <a href="https://elle.com.br/moda/martin-margiela">
              Martin Margiela, foi erguida como a antítese do culto à
              personalidade do criador
            </a>
            . As grandes estrelas sempre foram as roupas, a construção e a
            desconstrução delas. Galliano manteve – e mantém – essa essência,
            porém deixando sua personalidade transbordar cada vez mais.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Isso ficou claro assim que a pandemia chegou. Quer dizer, alguns
            meses depois, mais especificamente em julho de 2020, com a
            divulgação do primeiro vídeo lançado pela grife, no lugar do
            tradicional desfile de alta-costura, em Paris. Com quase 50 minutos
            de duração, o filme de moda da Margiela é um documentário com
            inserções de imagens poéticas de modelos vestindo looks da coleção.
          </p>
        </S.Text>
        <S.WrapperWrapper>
          <S.VideoWrapper
            className="wow animate__animated animate__zoomIn"
            data-wow-duration="1s"
          >
            <ReactPlayer
              className="react-player"
              url="https://www.youtube.com/watch?v=GCnbjRlICSQ"
              width="100%"
              height="100%"
              controls
            />
          </S.VideoWrapper>
        </S.WrapperWrapper>
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Numa versão cinematográfica da abertura e exposição que as redes
            sociais impuseram na vida de muita gente, Galliano esmiúça seu
            processo criativo, suas referências, suas reuniões, as conversas com
            a equipe e a troca com colaboradores para um público muito maior do
            que os convidados de uma apresentação tradicional.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            A tal corrida digital acelerada pela pandemia tinha esta pegadinha:
            a falsa democracia da acessibilidade. Todo mundo podia ver ao mesmo
            tempo o mesmo conteúdo do mesmo ponto de vista, é verdade. Porém o
            acesso a processos, detalhes, ideias e inspirações continuava
            exclusivo para alguns poucos. O inverno 2020 da Maison Margiela muda
            isso por completo.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Até aquele momento, John Galliano evitava ao máximo expor sua
            imagem. Entrevistas eram raríssimas. De repente, ele aparece de
            frente para as câmeras falando como associou a imagem de uma
            escultura grega às lembranças da época em que ia para boate em
            Londres e a outro movimento musical britânico para criar um vestido
            de alta-costura que imita o efeito de um tecido molhado sobre o
            corpo.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Assim, o estilo documental do vídeo não parece gratuito. É através
            dele que muitas celebridades com histórico de comportamentos
            erráticos buscam se desculpar e se reconectar com o público. Que
            isso tenha acontecido durante a pandemia, num momento de
            vulnerabilidade coletiva e suposta propensão empática, também não
            deve ter sido à toa.
          </p>
        </S.Text>
        <S.WrapperWrapper>
          <S.VideoWrapper
            className="wow animate__animated animate__zoomIn"
            data-wow-duration="1s"
          >
            <ReactPlayer
              className="react-player"
              url="https://www.youtube.com/watch?v=3bGmpHubaHo&t=15s"
              width="100%"
              height="100%"
              controls
            />
          </S.VideoWrapper>
        </S.WrapperWrapper>
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Na temporada de verão 2021 de prêt-à-porter, o formato se repete em
            versão mais dinâmica e com menos exposição. Já nas temporadas
            seguintes, o gosto por formato e narrativa cinematográficos partem
            para a ficção. O inverno 2021 de alta-costura e o verão 2022 de
            ready-to-wear são encenações de um filme de terror folclórico, que
            combinam referências aos grandes mestres holandeses de pintura com
            todo o romantismo e sexualidade, sempre presentes nas criações de
            Galliano.
          </p>
        </S.Text>
        <S.WrapperWrapper>
          <S.VideoWrapper
            className="wow animate__animated animate__zoomIn"
            data-wow-duration="1s"
          >
            <ReactPlayer
              className="react-player"
              url="https://www.youtube.com/watch?v=VwRdgdC5KyE"
              width="100%"
              height="100%"
              controls
            />
          </S.VideoWrapper>
        </S.WrapperWrapper>
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Indo um pouco além da imagem e das roupas, é interessante analisar
            algumas interpretações desses enredos. Principalmente do peso e da
            importância das tradições nas construções sociais e afetivas de uma
            pessoa ou comunidade. Como se sabe, o resultado de tais construções
            pode ser bem assustador. O inverno 2022 de alta-costura, do qual
            falamos acima, é uma extensão dessa ideia, mas um tanto menos
            pessimista e aterrorizante. Apesar da violência explícita e um tanto
            kitsch, a peça-filme de Galliano fala mais sobre vulnerabilidades,
            amores e liberdades.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            No fim, os gurus estavam certos. Contar histórias é tudo mesmo.
          </p>
        </S.Text>
        <S.Separator />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Raio-X de um desfile é a uma seção fixa da ELLE View, em que todos
            os meses examinamos uma apresentação recente, trazendo detalhes
            sobre as roupas e explicando por que vale a pena você saber mais
            sobre ela.
          </p>
        </S.Text>
      </S.Content>
    </S.Container>
  );
};

export default Main;
